import { useEffect, useRef } from 'react'

import { buttonContainerId, overlayId, previewScriptContainerId, widgetContainerId } from '../constants'

const useCreatePreview = ({
  backgroundColor,
  textColor,
  buttonColor,
  buttonHoverColor,
  language,
  productId,
  storeId,
  tryonMode,
}) => {
  const updateTimeOut = useRef()

  useEffect(() => {
    if (!backgroundColor || !textColor || !buttonColor || !buttonHoverColor) return

    if (updateTimeOut.current) {
      clearTimeout(updateTimeOut.current)
    }

    updateTimeOut.current = setTimeout(() => {
      const configurationObject = {
        background_color: backgroundColor,
        text_color: textColor,
        button_color: buttonColor,
        button_hover_color: buttonHoverColor,
        tryon_mode: tryonMode,
      }

      const params = new URLSearchParams()
      params.append('language', language)
      params.append('containerId', widgetContainerId)
      params.append('configuration', JSON.stringify(configurationObject))
      if (productId) params.append('productId', productId)
      if (storeId) params.append('storeId', storeId)
      params.append('buttonContainer', `#${buttonContainerId}`)
      // Cache buster to prevent the browser from serving a cached version of the script
      params.append('_t', Date.now())

      const container = document.getElementById(previewScriptContainerId)
      if (!container) return

      container.innerHTML = ''

      document.getElementById(widgetContainerId)?.remove()
      document.getElementById(overlayId)?.remove()

      const widgetContainer = document.createElement('div')
      widgetContainer.id = widgetContainerId
      container.parentNode.appendChild(widgetContainer)

      const script = document.createElement('script')
      script.src = `${import.meta.env.VITE_REVENI_TRY_ON_WIDGET}?${params.toString()}`
      container.appendChild(script)
    }, 500)

    return () => {
      clearTimeout(updateTimeOut.current)
      const container = document.getElementById(previewScriptContainerId)
      if (container) container.innerHTML = ''
      document.getElementById(widgetContainerId)?.remove()
      document.getElementById(overlayId)?.remove()
    }
  }, [backgroundColor, textColor, buttonColor, buttonHoverColor, language, productId, storeId, tryonMode])
}

export default useCreatePreview
